"use client";

import { PasswordResetUser } from "@/types/passwordReset";

import { usePasswordReset } from "@/context/passwordReset";

import QuestionButton from "@/components/question/button";
import StepButtonWrapper from "@/components/wrapper/stepButton";

export default function SecureButton() {
  const { errors, getAnswerValidity, passwordResetUser } = usePasswordReset();

  return (
    <StepButtonWrapper
      button={
        <QuestionButton<PasswordResetUser>
          entity={passwordResetUser}
          errors={errors}
          onClick={getAnswerValidity}
          questionDisabled={true}
          // startIcon={} TODO
          tooltipSuffix="to confirm your identity"
        />
      }
      gridSize={{ xs: 12, md: 6 }}
      containerJustifyContent="center"
    />
  );
}
